import React from "react";
import { useDispatch } from "react-redux";
import { updateActiveFilter } from "../../redux/userSlice";
import style from "./CategoryFilter.module.css"
const CategoryFilter = () => {
    const dispatch=useDispatch();
  return (
    <>
      <div className={style.filter}>
        <button onClick={()=>dispatch(updateActiveFilter("all"))}  >All</button>
        <button onClick={()=>dispatch(updateActiveFilter("food"))} >Food</button>
        <button onClick={()=>dispatch(updateActiveFilter("travel"))} >Travel</button>
        <button onClick={()=>dispatch(updateActiveFilter("entertainment"))} >Entertainment</button>
        <button onClick={()=>dispatch(updateActiveFilter("others"))} >Others</button>
      </div>
    </>
  );
};

export default CategoryFilter;
